import moment from 'moment-timezone';
import { CheckInData, UtcTime } from 'shared/models';

const oneBillion  =     1000000000; // (Mar 3, 1973)
const tenBillion  =    10000000000; // (Nov 20, 2286)

const oneTrillion =  1000000000000; // (Mar 3, 1973)
const tenTrillion = 10000000000000; // (Nov 20, 2286)


function parseDate(date: string | number): number {
    // TTG and old Matisses specify dates as string values
    if (typeof date === 'string') {
        return moment.utc(date, 'MM/DD/YYYY HH:mm:ss A').valueOf();
    }

    // MR5 and newer devices report dates in seconds since Jan 1, 1970
    // Convert from seconds to milliseconds
    if (date > oneBillion && date < tenBillion) {
        return date * 1000;
    }

    // Return milliseconds as is
    if (date > oneTrillion && date < tenTrillion) {
        return date;
    }

    return 0;
}

export function parseCheckInData(data: string, utcTime: UtcTime) {
    if (!data || !utcTime) return null;
    try {
        const checkInData = JSON.parse(data);
        checkInData.serverTime = utcTime;
        checkInData.CurrentTime = parseDate(checkInData.CurrentTime);
        checkInData.StartupTime = parseDate(checkInData.StartupTime);
        checkInData.LastUsedAt = parseDate(checkInData.LastUsedAt);
        return checkInData as CheckInData;
    }
    catch (err) {
        return null;
    }
}
